import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import logo from '../../Assets/favicon.ico';
import './Navigation.css'



const Navigation = () => {
    return (
        <div className="txbg container">
            <Navbar expand="lg" >
                <Container fluid>
                    <NavLink to="/home"><img className="logo" src={logo} alt="" /></NavLink>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll">
                        <Nav
                            className="ms-auto my-2 my-lg-0"
                            style={{ maxHeight: '100px' }}
                            navbarScroll
                        >
                            <NavLink className="mx-3 text-decoration-none" style={({ isActive }) =>
                            (
                                {
                                    color: isActive ? '#01C1DD' : 'white',
                                    fontWeight: isActive ? 'bold' : 'regular',
                                   
                                }

                            )}
                                to="/home">Home</NavLink>
                            
                            {/* ----------------------------------------------------------------------------------- */}
                            {/* <NavLink className="mx-3 text-decoration-none" style={({ isActive }) =>
                            (
                                {
                                    color: isActive ? '#01C1DD' : 'white',
                                    fontWeight: isActive ? 'bold' : 'regular',
                                   
                                   
                                }

                            )}
                                exact to="/projects">Projects</NavLink> */}
                            
                                {/* ----------------------------------------------------------------------------------- */}
                            <NavLink className="mx-3 text-decoration-none" style={({ isActive }) =>
                            (
                                {
                                    color: isActive ? '#01C1DD' : 'white',
                                    fontWeight: isActive ? 'bold' : 'regular',
                                   
                                   
                                }

                            )}
                                exact to="/aboutme">About Me</NavLink>
                            
                            {/* ----------------------------------------------------------------------------------- */}
                            
                            <NavLink className="mx-3 text-decoration-none" style={({ isActive }) =>
                            (
                                {
                                    color: isActive ? '#01C1DD' : 'white',
                                    fontWeight: isActive ? 'bold' : 'regular',
                                  
                                   
                                }

                            )} to="/contact">Contact Me</NavLink>

                                {/* ----------------------------------------------------------------------------------- */}
                            <NavLink className="mx-3 text-decoration-none" style={({ isActive }) =>
                            (
                                {
                                    color: isActive ? '#01C1DD' : 'white',
                                    fontWeight: isActive ? 'bold' : 'regular',
                                    
                                }

                            )} to="/blogs">Blogs</NavLink>
                                {/* ----------------------------------------------------------------------------------- */}
                        </Nav>

                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Navigation;